<template>
<transition name="fade">
    <div class="content-wrapper full-page-wrapper auth-pages login-2" style="background:#f8f8f8">
        <div class="row h-100">
       <!-- <particles-bg type="random" :bg="true" />  -->
       <div class="col-2"></div>
            <section class="col-lg-4 carouselPanel d-none d-sm-none d-md-block text-left pt-5 mt-5" >

                <div class="col-12 text-left pl-0 mb-0 pb-0">
                        <img src="/images/logo_large.png" alt="" width="200px">
                    </div>
                <ul class="register-imp">
                    <li>
                        <h4>Démarrage rapide</h4>
                        <p>Réalisez vos intégrations par la biais d'API pensées pour les développeurs, ou choisissez des solutions préconfigurées ou nécessitant peu de code.</p>
                    </li>
                    <li>
                         <h4>Prenez en charge tous les modèles économiques</h4>
                        <p>
                            E-commerce, abonnements, plateformes SaaS, places de marché et bien plus encore, le tout sur une plateforme unifiée.
                        </p>
                    </li>
               <li>
                         <h4>Rejoignez des millions d'entreprises</h4>
                        <p>
                            Des startups ambitieuses et des entreprises de toutes tailles font confiance à Intram.
                        </p>
                    </li>
                    <div>
                        <a href="#">© Intram</a> &nbsp;&nbsp;
                        <a href="#">Confidentialité et CGU</a>
                    </div>
                </ul>
           </section>
            <section class="col-lg-4 carouselPanel loginPanel">
                <div class="card">
                <div class="card-body px-5 py-5">
                <!--     <div class="text-uppercase" style="background: #29B3A6;color:#fff;padding:15px 10px 2px 10px;text-align:center;border-radius:20px">
                        <h6 v-if="baner===3">Vos informations sont 100% sécurisées et confidentielles</h6>
                        <h6 v-if="baner===2">Gérer vos opérations depuis une plateforme simple d’utilisation</h6>
                        <h6 v-if="baner===1">Payez, Recevez et envoyez de l’argent partout et à tout moment !</h6>
                    </div> -->

                    <h5 class="text-left  pt-5 col-12 mb-0">
                         <span style="border-radius:10px;margin-bottom:5px"> Créez votre compte Intram </span>
                            <br>
                            <small class="mt-2">
 Créez un compte et recevez vos paiement en ligne à partir de maintenant. </small>                           </h5>



                    <div class=" col-lg-12 col-xs-12 mb-5">
                        <span class="text-center ">Vous avez dejà un  compte ? <router-link to="/login" class="connect-btn"
                         style="font-weight:bold; color: #fff!important;"> Connectez-vous </router-link></span>
                    </div>
                        <v-alert v-if="errors.register_error===true" style="text-align: center;"   dense outlined type="warning">{{$t(errors.register_message)}}</v-alert>
                        <v-alert  v-if="errors.register_error===false" style="text-align: center;"  dense outlined type="success">{{$t(errors.register_message)}}</v-alert>
                  <div class="col-12">
                    <form class="row"  @submit.prevent="submitForm">
                        <div class="form-group col-ms-12 col-lg-12 pt-0">
                            <label class="form-label">Votre adresse électronique <span class="requiredCheck">*</span></label>
                            <input v-model="email" type="text" class="form-control p_input input-error" placeholder="Votre adresse e-mail">
                            <span class="error-box" v-show="errors.email">{{errors.email}}</span>
                        </div>
                        <div class="form-group col-ms-12 col-lg-12 pt-0">
                            <label for="countries" class="form-label">Votre pays <span class="requiredCheck">*</span></label>
                             <vselect id="countries" background-color="white" placeholder="Veuillez choisir un pays" v-model="country" label="_name" :reduce="country => country._id" :options="countries"></vselect>
                                <input type="hidden" name="pays" :value="country">
                            <span class="error-box" v-show="errors.country">{{errors.country}}</span>
                        </div>
                        <div class="form-group col-ms-12 col-lg-12 pt-0">
                            <label class="form-label">Créez un mot de passe <span class="requiredCheck">*</span></label>
                            <input v-model="password" type="password" class="form-control p_input" placeholder="Créer un mot de passe">
                            <span class="error-box" v-show="errors.password">{{errors.password}}</span>

                        </div>
                        <div class="form-group col-ms-12 col-lg-12 pt-0">
                            <label class="form-label">Confirmez votre mot de passe <span class="requiredCheck">*</span></label>
                            <input v-model="password_confirmation" type="password" class="form-control p_input" placeholder="Confirmer le mot de passe">
                            <span class="error-box" v-show="errors.password_confirmation">{{errors.password_confirmation}}</span>

                        </div>
                        <div style="text-align: center" class="col-lg-12 col-xs-12 pt-0 pb-0">
                        <div style="text-align: center" class="col-lg-12 col-xs-12 submit_panel " v-if="submitting && !successfully">
                            <img style="width: 30px" alt="loader" v-lazy="'/loaders/loader.gif'"/> souscription en cours en cours ...
                        </div>
                        <div style="text-align: center" class="col-lg-12 col-xs-12 redirection_panel " v-if="!submitting && successfully">
                            <img style="width: 30px" alt="loader" v-lazy="'/loaders/loader.gif'"/> Souscription validé avec succès ! Redirection en cours ...
                        </div>
                        </div>
                        <div class="text-center col-lg-12 col-xs-12 " v-if="!submitting && !successfully">
                        <button v-show="!successfully" type="submit" class="btn btn-default btn-md enter-btn">CREEZ VOTRE COMPTE</button>
                        </div>

                    </form>
                </div>
                </div>
                </div>
            </section>
        </div>
    </div>
</transition>
</template>

<script>
    /* eslint-disable */
import $ from 'jquery'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

    import {mapState} from "vuex";
    import Swal from "sweetalert2";
    import helpers from "../../mixins/helpers";
    export default {
        name: "Register",
        props:['settings'],
        components:{'vselect':vSelect},
      mixins:[helpers(this)],
      data(){
            return{
                baner:(Math.floor(Math.random() * 3) + 1),
                errors:{},
                email:null,
                password:null,
                country:null,
                password_confirmation:null,
                successfully:false,
                canSubmit:true,
                submitting:false,
            }
        },
        mounted(){
            this.$store.dispatch('auth/getCountries').then(response => {});
        },
        computed :{
            ...mapState('auth/',['countries']),
          ...mapState('generalsettings/',['generals']),

        },
        methods:{
            checkisDashboard(){
                this.$emit('checkisDashboard',false);
            },
            submitForm(){
                let VueBox = this;
                this.validateForm();
                if (!this.canContinue){
                    return;
                }
                let formData = new FormData();
                formData.append('email',this.email);
                formData.append('password',this.password);
                formData.append('country',this.country);
               /* let data = {
                    email:this.email,
                    password:this.password,
                    country:this.country
                }*/
               // window.console.log('data to send',data);
               // let formData = new FormData($('#login-form')[0]);
                this.submitting = true;
                this.errors = {};
                this.$store.dispatch("auth/register",formData).then(response =>{
                    window.console.log(response);
                    this.submitting = false;
                    this.errors.register_error = response.error;
                    this.errors.register_message = response.message;
                    if (!response.error){
                        this.resetDatas(VueBox);
                        Swal.fire({
                            icon: 'success',
                            timerProgressBar: false,
                            text: this.$t(response.message),
                            position: 'top-end',
                            showConfirmButton: true,
                            confirmButtonColor:'#29B3A6'
                        }).then(()=>{
                            VueBox.$router.push('/login');
                        })
                    }
                });
            },
            validateForm(){
                this.errors = {};
                if (this.email===null || this.email.trim().length===0){
                    this.errors.email= this.$t('email_required');
                }else{
                    if (!this.isValidEmailAddress(this.email)){
                        this.errors.email =  this.$t('invalid_email');
                    }
                }
                if (this.password===null || this.password.trim().length===0){
                    this.errors.password= this.$t('password_required');
                }

                if (this.password && this.password.trim().length<this.getSetting('nmcpw')){
                    this.errors.password= this.$t('min_8_caracters',{number:this.getSetting('nmcpw')});
                }
                if (this.password_confirmation && this.password_confirmation.trim().length<this.getSetting('nmcpw')){
                    this.errors.password_confirmation= this.$t('min_8_caracters',{number:this.getSetting('nmcpw')});
                }
                if (this.country===null || this.country.trim().length===0){
                    this.errors.country= this.$t('country_required');
                }
                if (this.password_confirmation===null || this.password_confirmation.trim().length===0){
                    this.errors.password_confirmation= this.$t('confirmation_password_required');
                }else{
                    if (this.password!==this.password_confirmation){
                        this.errors.password_confirmation= this.$t('password_mismatch');
                    }
                }
                this.canContinue = Object.keys(this.errors).length===0 ;
            },
            resetDatas(component){
                Object.assign(component.$data, component.$options.data.apply(component))
            },
            getCountries(){
                let selectCountries = [{
                    text: "name1",
                    value: "value1"
                }, {
                    text: "name2",
                    value: "value2"
                }, {
                    text: "name3",
                    value: "value3"
                }];
                this.countries.forEach((country)=>{
                    selectCountries.push({
                        text:country._name,
                        value:country._id
                    })
                });
                return selectCountries;
            }
        },
        created() {
            this.checkisDashboard();
        }
    }
</script>

<style scoped>
.redirection_panel,.submit_panel {
    color: #fff;
}
   .form-label{
        font-size: 12pt;
        font-weight: 500;
        color: #fff;
    }

.register-imp li, .register-imp h4{
    color:#373737
}
.register-imp li{
    background: #f5f2f2;
    padding: 15px 10px 5px 10px;
    margin-bottom: 10px;
    border-radius: 6px;
}
.register-imp{
    padding: 0;
    margin-top: 10px;
   list-style-type: none;
}

.register-imp h4{
   font-size: 17px;
}
    .auth-pages .form-group{
        margin-bottom: 5px !important;
    }
    .model-input{
        padding: 0 90px !important;
    }
    .submit_panel{
        padding: 5px;
        font-weight: 500;
        font-size: 10pt;
         color: rgb(31, 23, 23);
        text-transform: uppercase;
    }
    .redirection_panel{
        padding: 5px;
        font-weight: 500;
        font-size: 9pt;
        color: rgb(31, 23, 23);
        text-transform: uppercase;
        border-radius: 6px;
    }
    #countries{
        color: #0D0A0A !important;
    }
    .connect-btn{
        color: #fff;
        font-weight: 500;
        text-decoration: underline;
    }
    .loginPanel .card{
        margin-top: auto;
margin-bottom: auto;
        /*  background-image: linear-gradient(#f8f8f8, #29B3A6);  */
        background-color: #29B3A6;
        box-shadow: 0px 0px 1.875rem rgb(6 71 124 / 17%);
    }
    .card{
        background: transparent;
        box-shadow: none !important;
        border: none !important;
    }
    .loginPanel{
        padding: 20px!important;
        min-height: 100vh;
        display: flex;
  align-items: center;
    }
    .requiredCheck{
        color: red;
    }
    .loginBottom{
        font-size: 12pt;
    }

    #loginCarousel{
        max-height: 100vh;
    }

    .carousel-inner{
        height: 100%;
    }
    .carousel-inner{
        background-size: cover;
        text-align: center;
    }
    .qrPanel{
        color:#fff;
        position: absolute;
        bottom: 70px;
        left: 17vw;
        width: 350px;
        padding: 20px;
        background: rgba(16, 70, 65, 0.8);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
        border-radius: 23px;
        font-size: 11pt;
        font-weight: bold;
    }
    .qrPanel img{
        width: 250px !important;
    }

    .qrPanel span{
        padding: 20px;
        margin-top: 20px;
        font-size: 11pt;
        font-weight: bold;
        text-transform: uppercase;
        color: #fff;
    }

    .carouselPanel{
        padding: 0;
    }
    .card-image{width: 250px}
    .auth-pages .form-group .form-control{border-radius: 6px;height: 40px;border: 1px solid rgba(0, 0, 0, 0.15);}
    .wrapper{
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .background-3 {
        /*box-shadow: inset 0 0 100px hsla(0,0%,0%,.3);*/
    }


    .auth-pages .form-group .form-control:focus{
        transition-duration: 5ms;
        border: 1px solid rgba(41, 179, 166, 1);
    }
    .auth-pages .form-group .form-control:hover{
        border: 1px solid rgba(41, 179, 166, 1);
        transition-duration: 5ms;
    }
.auth-pages.login-2 .card{
    min-height: unset;
}
    @media (max-width: 991px) {
        .model-input{
            padding: 0 25px !important;
        }
    }
    .carousel-item img{
        width: 100%;
    }
    .carousel-indicators li{
        color:#373737
    }
     .carouselPanel{
        color: #fff !important;
    }
    .auth-pages button{
        font-size: 1rem;
    }
    .forgot-pass{
       color: #fff !important;
    }
</style>
